// extracted by mini-css-extract-plugin
export default {"settingsDetail":"SettingsDetail_settingsDetail__HlXEH","carousel_item":"SettingsDetail_carousel_item__2iFMT","carousel_title":"SettingsDetail_carousel_title__nebOR"};